<div id="exportar-pdf">
  <section>
    <app-cabecalho-relatorio></app-cabecalho-relatorio>
    <app-rotulo-cabecalho [cliente]="relatorio?.cabecalho?.nomeCliente"
      [contrato]="relatorio?.cabecalho?.contratoCliente" [cnpj]="relatorio?.cabecalho?.cnpjCliente"
      [tipoDeContrato]="relatorio?.cabecalho?.tipoContratoCliente"
      [mesReferencia]="relatorio?.cabecalho?.vencimento?.mesReferencia"
      [vencimento]="relatorio?.cabecalho?.vencimento?.vencimento "
      [faturaNumero]="relatorio?.cabecalho?.vencimento?.numeroFatura" [valor]="relatorio?.cabecalho?.valorFatura"
      [dataEmissao]="relatorio?.cabecalho?.vencimento?.dataEmissao"
      [emissao]="relatorio?.cabecalho?.vencimento?.emissao"></app-rotulo-cabecalho>
  </section>
  <div *ngFor="let detalhe of relatorio?.detalhamento">
    <app-tabela-relatorio [equipamento]="detalhe?.nomeEquipamento"
      [cabecalhosTabela]="['PATRIMÔNIO', 'DESCRIÇÃO', 'ANT. P&B', 'ATU. P&B', 'SALDO P&B', 'FRAQUIA P&B', 'VALOR EXC. P&B', 'ANT COR', 'ATU COR', 'SALDO COR', 'FRANQUIA COR', 'VALOR EXC. COR', 'VALOR FRANQUIA', 'VALOR EXCED', 'DATA LEIT.', 'CONTATO']"
      >
      <tr *ngFor="let detalhesTabela of detalhe.informacoesTabela">
        <ng-container class="cabecalho__tabela">
          <td class="item__tabela">{{ detalhesTabela.patrimonio }}</td>
          <td class="item__detalhamento">{{ detalhesTabela.equipamento }}</td>
          <td class="item__tabela">{{ detalhesTabela.antPB }}</td>
          <td class="item__tabela">{{ detalhesTabela.atuPB }}</td>
          <td class="item__tabela">{{ detalhesTabela.saldoPB }}</td>
          <td class="item__tabela">{{ detalhesTabela.franquiaPB }}</td>
          <td class="item__tabela">{{ detalhesTabela.valorExcPB }}</td>
          <td class="item__tabela">{{ detalhesTabela.antCor }}</td>
          <td class="item__tabela">{{ detalhesTabela.atuCor }}</td>
          <td class="item__tabela">{{ detalhesTabela.saldoCor }}</td>
          <td class="item__tabela">R$ {{ detalhesTabela.valorExcCor }}</td>
          <td class="item__tabela">R$ {{ detalhesTabela.valorExcedente }}</td>
          <td class="item__tabela">R${{ detalhesTabela.valorFranquia }}</td>
          <td class="item__tabela">{{ detalhesTabela.franquiaCor }}</td>
          <td class="item__tabela">{{ detalhesTabela.dataLeit | date: "dd/MM/yyyy" }}</td>
          <td class="item__tabela">{{ detalhesTabela.contato }}</td>
        </ng-container>
      </tr>
    </app-tabela-relatorio>
    <div>
      <div>
        <app-rodape-tabela-relatorios [tipoRelatorio]="relatorio?.cabecalho?.razaoNotaFiscalRelatorioTipo"
          [subtotalModeloPb]="detalhe?.pB" [subtotalModeloCor]="detalhe?.cor">
        </app-rodape-tabela-relatorios>
      </div>
    </div>
  </div>
  <app-rodape-relatorio [valorTotalDaFatura]="relatorio?.cabecalho?.valorFatura"
    [tipoRelatorio]="relatorio?.cabecalho?.razaoNotaFiscalRelatorioTipo">
    <div>
      <div class="infos__gerais__resumo__total">
        <div class="infos__resumo__total">
          <span class="titulo__categoria">VALOR TOTAL DE EQUIPAMENTOS + FRANQUIAS</span>
          <p class="informacao__valor">
            R$ {{ relatorio?.resumoTotal?.valorFranquia }}
            <!-- obs: verificar isso aqui -->
          </p>
        </div>
        <div class="infos__resumo__total">
          <span class="titulo__categoria">VALOR TOTAL DE IMPRESSÕES EXCEDENTES</span>
          <p class="informacao__valor">
            R$ {{ relatorio?.resumoTotal?.valorExcedente }}
          </p>
        </div>
      </div>
    </div>
  </app-rodape-relatorio>
</div>
